import script from "./contactDisplayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./contactDisplayer.vue?vue&type=script&setup=true&lang=ts"

import "./contactDisplayer.vue?vue&type=style&index=0&id=653d54ff&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653d54ff"]])

export default __exports__